/**
 * Coalesced Redis draft writes for the canvas editor.
 * Prevents stale in-flight writes from overwriting newer local state.
 */

let state = {
  writing: false,
  pending: null,
  leaveGen: 0,
};

/** Cancel pending draft writes (call when leaving editor). */
export function cancelCanvasDraftWrites() {
  state.pending = null;
  state.leaveGen += 1;
}

async function flushDraftQueue(request, checkLeaving, onWritten) {
  while (state.pending) {
    const job = state.pending;
    state.pending = null;
    if (checkLeaving && checkLeaving()) {
      return;
    }
    if (job.gen !== state.leaveGen) {
      continue;
    }
    state.writing = true;
    try {
      await request.setProjectCache({ key: job.key, value: job.value });
      if (onWritten && job.gen === state.leaveGen) {
        onWritten(job.value);
      }
    } catch (e) {
      /* draft failure must not block editing */
    } finally {
      state.writing = false;
    }
  }
}

/**
 * Queue a draft write; only the latest payload is flushed when idle.
 * Always updates local vuex via caller before/after as needed.
 */
export async function coalescedSetProjectCache(
  request,
  { key, value, checkLeaving, onWritten }
) {
  if (!key || !request) {
    return false;
  }
  if (checkLeaving && checkLeaving()) {
    return false;
  }
  const gen = state.leaveGen;
  state.pending = { key, value, gen };
  if (state.writing) {
    return false;
  }
  await flushDraftQueue(request, checkLeaving, onWritten);
  return true;
}
